// export const baseUrl = process.env.REACT_APP_SURVEY_SERVICE_URL;
// export const userServiceUrl = process.env.REACT_APP_USER_SERVICE_URL;
// export const calendarServiceUrl = process.env.REACT_APP_CALENDAR_SERVICE_URL;
// export const medicineServiceUrl = process.env.REACT_APP_MEDICINE_SERVICE_URL;
// export const medicineServiceVersion =
//   process.env.REACT_APP_MEDICINE_SERVICE_VERSION;
// export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
// export const dmsUrl = process.env.REACT_APP_DMS_SERVICE_URL;

export const origin = window?.env?.appOrigin ?? process.env.REACT_APP_ORIGIN;
export const adminUrl = window?.env?.adminServiceUrl ?? process.env.REACT_APP_ADMIN_SERVICE_URL;
export const keycloakUrl = window?.env?.keycloakUrl ?? process.env.REACT_APP_KEYCLOAK_URL;
export const realm = window?.env?.keycloakRealm ?? process.env.REACT_APP_REALM;
export const clientId = window?.env?.keycloakClientId ?? process.env.REACT_APP_CLIENT_ID;
export const authUrl = window?.env?.appAuthUrl ?? process.env.REACT_APP_AUTH_URL;
export const redirectUri = window?.env?.appRedirectUri ?? process.env.REACT_APP_REDIRECT_URI;

// export const logoutUrl = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/logout?client_id=${clientId}&redirect_uri=${origin}/login`;
export const logoutUrl = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/logout?client_id=${clientId}&post_logout_redirect_uri=${origin}/login`;
